<div class="end-center flex-row" style="height: 40px">
    <button mat-icon-button (click)="cancel()">
        <mat-icon class="button-icon">close</mat-icon>
    </button>
</div>
<div class="center-center flex-row flex" style="height: 100%; padding: 0px 50px">
    @if (!images || images.length < 2) {
        <img [src]="imgUrl" class="current-image" alt="Current Image" />
    }
    @if (images && images.length > 1) {
        @for (img of images; track img; let i = $index) {
            @if (imgIndex === i) {
                <img [src]="img" class="current-image" alt="Current Image" />
            }
        }
    }

    @if (images?.length > 1) {
        <div class="center-center space-between-start full-width">
            <button mat-icon-button (click)="previousImage()">
                <mat-icon class="button-icon">chevron_left</mat-icon>
            </button>

            <button mat-icon-button (click)="nextImage()">
                <mat-icon class="button-icon">chevron_right</mat-icon>
            </button>
        </div>
    }
</div>
